/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import Icon from "../GlobalComponents/Icon";
import GymTitle from "./GymTitle";
import GymProgramCard from "./GymProgramCard";
import Container from "../GlobalComponents/Container";

const GymProgram = () => (
  <div css={styles} className="gymProgram" id="facility">
    <GymTitle />
    <Icon />
    <Container>
      <GymProgramCard
        title="Free Wi-Fi"
        desc="We are offering fast internet with unlimited data."
      />
      <GymProgramCard
        title="CCTV Cameras"
       desc="Availbale in common area."
      />
      <GymProgramCard
        title="Clean and chilled water"
        desc="Water cooler available"
      />
      <GymProgramCard
        title="Power Back-up"
        desc="Available"
      />
      <GymProgramCard
        title="Parking Space"
        desc="2-Wheeler Parking"
      />
      <GymProgramCard
        title="Geyser"
        desc="Everyone needs hot water for bathing in winter, so we installed."
      />
      <GymProgramCard
        title="Storage for luggage"
       desc="We provided you covered for luggage in each room."
      />
      <GymProgramCard
        title="Comfortable beds"
       desc="Available"
      />
     
    </Container>
  </div>
);

const styles = css`
  width: 100%;
  min-height: 80vh;
  text-align: center;
  padding: 10px 0;
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0px 0;
  }
  @media (max-width: 700px) {
    .container {
      flex-direction: column;
      justify-content: flex-start;
    }
  }
  @media (min-width: 701px) and (max-width: 1100px) {
    .container {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export default GymProgram;
